"use strict";var e=require("@apollo/client").gql`
  mutation updateCustomerDocumentId(
    $customerId: ID!
    $documentId: String!
    $documentType: String
  ) {
    updateCustomerDocumentId(
      customerId: $customerId
      documentId: $documentId
      documentType: $documentType
    ) {
      id
      name
      documentId
    }
  }
`;exports.u=e;